import { stringifyValues } from 'atc-js';
var stringifyForDataLayer = function stringifyForDataLayer(obj, inheritPageData) {
  if (inheritPageData === void 0) {
    inheritPageData = true;
  }
  var defaultNonValue = inheritPageData ? undefined : null;
  return Object.entries(obj).reduce(function (acc, _ref) {
    var key = _ref[0],
      value = _ref[1];
    var stringifiedValue = stringifyValues(value, {
      separator: '|'
    }) || defaultNonValue;
    acc[key] = stringifiedValue == null ? void 0 : stringifiedValue.toLowerCase();
    return acc;
  }, {});
};
export default stringifyForDataLayer;